import React, { Component } from 'react';

class LoginPageParent extends Component {
	render() {
		return <div className = "loginPage">
				{this.props.children}
		</div>
	}
}

export default LoginPageParent;



// WEBPACK FOOTER //
// ./src/components/login/LoginPageParent.js